import { NgModule } from '@angular/core';

import { FuseSearchBarModule, FuseShortcutsModule } from '@fuse/components';
import { FuseSharedModule } from '@fuse/shared.module';
import { LanguageService } from 'app/services/language.service';

import { SharedModule } from "../../../shared/shared.module";
import { LanguageSelectorComponent } from './language-selector.component';


@NgModule({
    declarations: [
        LanguageSelectorComponent
    ],
    imports: [
        SharedModule,

        FuseSharedModule,
        FuseSearchBarModule,
        FuseShortcutsModule
    ],
    exports: [
        LanguageSelectorComponent
    ],
    providers:[LanguageService]
})
export class LanguageSelectorModule {
}
